import { theme, spacing, typography } from '../styles/theme';
import { useState } from 'react';

export default function Footer() {
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <footer style={{
      backgroundColor: theme.bg.dark,
      color: theme.text.inverse,
      borderTop: `2px solid ${theme.brand.primary}`,
      flexShrink: 0,
      position: 'relative', // For positioning the expand tab
    }}>
      {/* Expand Tab (makes it obvious it's expandable) */}
      <div
        onClick={() => setIsExpanded(!isExpanded)}
        style={{
            position: 'absolute',
            top: '-26px',
            right: spacing.xl,
            backgroundColor: theme.bg.dark,
            color: theme.brand.primary,
            padding: `${spacing.xs} ${spacing.lg}`,
            borderRadius: '8px 8px 0 0',
            cursor: 'pointer',
            fontSize: typography.fontSize.xs,
            fontWeight: typography.fontWeight.semibold,
            border: `2px solid ${theme.brand.primary}`,
            borderBottom: 'none',
            transition: 'all 0.2s',
            display: 'flex',
            alignItems: 'center',
            gap: spacing.xs,
            boxShadow: theme.shadow.small,
            ...(window.innerWidth <= 768 && {
            right: spacing.md,
            padding: `${spacing.xs} ${spacing.md}`,
            })
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.backgroundColor = 'rgba(139, 92, 246, 0.1)';
          e.currentTarget.style.transform = 'translateY(-2px)';
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.backgroundColor = theme.bg.dark;
          e.currentTarget.style.transform = 'translateY(0)';
        }}
      >
        <span>{isExpanded ? 'Less Info' : 'About & Legal'}</span>
        <span style={{
          transition: 'transform 0.2s',
          transform: isExpanded ? 'rotate(180deg)' : 'rotate(0deg)',
          display: 'inline-block',
        }}>
          ▼
        </span>
      </div>

      {/* Collapsed View (Always Visible) */}
      <div style={{
        padding: `${spacing.sm} ${spacing.xl}`,
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        ...(window.innerWidth <= 768 && {
          padding: `${spacing.xs} ${spacing.md}`,
          flexDirection: 'column',
          gap: spacing.xs,
          textAlign: 'center',
        })
      }}>
        <div style={{
          fontSize: typography.fontSize.xs,
          color: theme.text.muted,
        }}>
          © {new Date().getFullYear()} Judgy • Not affiliated with WotC
        </div>

        <div style={{
          display: 'flex',
          alignItems: 'center',
          gap: spacing.md,
          fontSize: typography.fontSize.xs,
          ...(window.innerWidth <= 768 && {
            flexWrap: 'wrap',
            justifyContent: 'center',
          })
        }}>
          <a href="/privacy" style={{
            color: theme.text.inverse,
            textDecoration: 'none',
            transition: 'color 0.2s',
          }}
          onMouseEnter={(e) => e.target.style.color = theme.brand.primary}
          onMouseLeave={(e) => e.target.style.color = theme.text.inverse}>
            Privacy
          </a>

          <span style={{ color: theme.text.muted }}>•</span>

          <a href="/terms" style={{
            color: theme.text.inverse,
            textDecoration: 'none',
            transition: 'color 0.2s',
          }}
          onMouseEnter={(e) => e.target.style.color = theme.brand.primary}
          onMouseLeave={(e) => e.target.style.color = theme.text.inverse}>
            Terms
          </a>

          <span style={{ color: theme.text.muted }}>•</span>

          <a href="/about" style={{
            color: theme.text.inverse,
            textDecoration: 'none',
            transition: 'color 0.2s',
          }}
          onMouseEnter={(e) => e.target.style.color = theme.brand.primary}
          onMouseLeave={(e) => e.target.style.color = theme.text.inverse}>
            About
          </a>

          <span style={{ color: theme.text.muted }}>•</span>

          <a href="/faq" style={{
            color: theme.text.inverse,
            textDecoration: 'none',
            transition: 'color 0.2s',
          }}
          onMouseEnter={(e) => e.target.style.color = theme.brand.primary}
          onMouseLeave={(e) => e.target.style.color = theme.text.inverse}>
            FAQ
          </a>

          <span style={{ color: theme.text.muted }}>•</span>

          <a href="mailto:support@askjudgy.com" style={{
            color: theme.text.inverse,
            textDecoration: 'none',
            transition: 'color 0.2s',
          }}
          onMouseEnter={(e) => e.target.style.color = theme.brand.primary}
          onMouseLeave={(e) => e.target.style.color = theme.text.inverse}>
            Contact
          </a>
        </div>
      </div>

      {/* Expanded View */}
      {isExpanded && (
        <div style={{
            padding: `${spacing.lg} ${spacing.xl}`,
            borderTop: `1px solid rgba(255, 255, 255, 0.1)`,
            animation: 'slideDown 0.3s ease-out',
            ...(window.innerWidth <= 768 && {
            padding: `${spacing.md} ${spacing.md}`,
            })
        }}>
            {/* Disclaimers */}
            <div style={{
                display: 'flex',
                gap: spacing.xl,
                alignItems: 'center',
                maxWidth: '1100px',
                margin: '0 auto',
                marginBottom: spacing.xl,
                ...(window.innerWidth <= 768 && {
                    flexDirection: 'column',
                    gap: spacing.lg,
                })
            }}>
                {/* Logo - Left side */}
                <div style={{
                    flexShrink: 0,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    paddingRight: spacing.xl,
                    ...(window.innerWidth <= 768 && {
                    paddingRight: 0,
                    marginBottom: spacing.md,
                    })
                }}>
                    <img 
                    src="/logo-light.svg" 
                    alt="Judgy"
                    style={{
                        height: '60px',
                        width: 'auto',
                        opacity: 0.8,
                        ...(window.innerWidth <= 768 && {
                        height: '48px',
                        })
                    }}
                    />
                </div>

                {/* Disclaimers - Right side */}
                <div style={{
                    flex: 1,
                    fontSize: typography.fontSize.xs,
                    color: theme.text.muted,
                    lineHeight: typography.lineHeight.relaxed,
                }}>
                    <p style={{ marginBottom: spacing.md }}>
                        <strong style={{ color: theme.text.inverse }}>Unofficial Fan Project:</strong> Judgy is not affiliated with, endorsed by, or sponsored by Wizards of the Coast LLC. It is an unofficial fan project permitted by Wizard's Fan Content Policy. Magic: The Gathering, MTG, and all related card names, logos, and artwork are trademarks and copyrights of Wizards of the Coast LLC.
                    </p>
                    <p style={{ marginBottom: spacing.md }}>
                        <strong style={{ color: theme.text.inverse }}>Not a Judge Replacement:</strong> Responses are generated using AI and may contain errors. Always consult official rules or certified judges for tournament play. Judgy is for casual reference only.
                    </p>
                    <p style={{ margin: 0 }}>
                        <strong style={{ color: theme.text.inverse }}>Rules Source:</strong> Citations are based on the Magic: The Gathering Comprehensive Rules, copyright Wizards of the Coast.
                    </p>
                </div>
            </div>

            {/* Attributions - Same as before */}
            <div style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                gap: spacing.lg,
                fontSize: typography.fontSize.xs,
                color: theme.text.muted,
                paddingTop: spacing.lg,
                borderTop: `1px solid rgba(255, 255, 255, 0.05)`,
                flexWrap: 'wrap',
            }}>
                <span>Powered by:</span>
            
                <a href="https://scryfall.com" target="_blank" rel="noopener noreferrer" style={{
                    color: theme.brand.primary,
                    textDecoration: 'none',
                    fontWeight: typography.fontWeight.medium,
                    transition: 'opacity 0.2s',
                    }}
                    onMouseEnter={(e) => e.target.style.opacity = '0.8'}
                    onMouseLeave={(e) => e.target.style.opacity = '1'}
                >
                        Scryfall
                </a>

            <span style={{ color: theme.text.muted }}>•</span>

            <a href="https://openai.com" target="_blank" rel="noopener noreferrer" style={{
                color: theme.brand.primary,
                textDecoration: 'none',
                fontWeight: typography.fontWeight.medium,
                transition: 'opacity 0.2s',
            }}
            onMouseEnter={(e) => e.target.style.opacity = '0.8'}
            onMouseLeave={(e) => e.target.style.opacity = '1'}>
                OpenAI
            </a>

            <span style={{ color: theme.text.muted }}>•</span>

            <a href="https://magic.wizards.com/en/rules" target="_blank" rel="noopener noreferrer" style={{
                color: theme.brand.primary,
                textDecoration: 'none',
                fontWeight: typography.fontWeight.medium,
                transition: 'opacity 0.2s',
            }}
            onMouseEnter={(e) => e.target.style.opacity = '0.8'}
            onMouseLeave={(e) => e.target.style.opacity = '1'}>
                WotC Rules
            </a>
            </div>
        </div>
        )}

      {/* Add CSS animation */}
      <style>{`
        @keyframes slideDown {
          from {
            opacity: 0;
            max-height: 0;
            transform: translateY(-10px);
          }
          to {
            opacity: 1;
            max-height: 500px;
            transform: translateY(0);
          }
        }
      `}</style>
    </footer>
  );
}